import React from 'react'
import './about.css';
import aboutImage from '../Myimages/about.avif'
import { FaArrowRight} from 'react-icons/fa' // Import the forward icon
export default function about() {
  return (
     <div className='about-main  py-8' id='about'>
        <div className='bg-[var(--card-bg)] h-auto text-white py-10  mx-12 rounded-2xl my-54  text-center justify-center ' >
           <div className='flex flex-col justify-center items-start gap-24 mx-28'>
              <h1 className='main-heading text-2xl md:text-4xl font-bold px-15'>About</h1>
              <div className='about grid grid-cols-2 grid-rows-3 gap-x-24'>
                 <div className=' Bounce row-span-2 w-[35rem] h-[20rem]'>
                    <img className='w-[100%] h-[20rem]    rounded-3xl' src={aboutImage} alt=" About Image" />

                 </div>
                 <div className='about-box flex gap-6 pb-12 px-11'>
                    <FaArrowRight size={24} className='mt-10' /> {/* Forward icon here */}
                    <span className='w-96'>

                       <h1 className='text-2xl font-bold py-4'>
                          HTML
                       </h1>
                       <p className=' tracking-tighter'>
                          HTML (HyperText Markup Language) is the standard language used to create the structure of web pages. It defines elements like headings, paragraphs, images, and links. Every website is built on a foundation of HTML.
                       </p>

                    </span>

                 </div>
                 <div className='about-box flex gap-6 pb-12 px-11'>
                    <FaArrowRight size={24} className='mt-10' /> {/* Forward icon here */}
                    <span className='w-96'>

                       <h1 className='text-2xl font-bold py-4'>
                      CSS
                       </h1>
                       <p className=' tracking-tighter'>
                          CSS (Cascading Style Sheets) is used to style and design the layout of web pages. It controls colors, fonts, spacing, and overall visual appearance. While HTML builds the structure, CSS makes it look attractive and user-friendly.
                       </p>

                    </span>

                 </div>
                 <div className='about-box flex gap-6 pb-12 px-11'>
                    <FaArrowRight size={24} className='mt-10' /> {/* Forward icon here */}
                    <span className='w-96'>

                       <h1 className='text-2xl font-bold py-4'>
                        REACT.JS
                       </h1>
                       <p className=' tracking-tighter'>
                          React is a popular JavaScript library used to build fast and interactive user interfaces. It lets developers create reusable components and efficiently manage data with a virtual DOM. React is widely used for building modern single-page applications (SPAs).
                       </p>

                    </span>

                 </div>
                 <div className='about-box flex gap-6 pb-12 px-11'>
                    <FaArrowRight size={24} className='mt-10' /> {/* Forward icon here */}
                    <span className='w-96'>

                       <h1 className='text-2xl font-bold py-4'>
                       JAVA SCRIPT
                       </h1>
                       <p className=' tracking-tighter'>
                          JavaScript is a powerful programming language that adds interactivity and dynamic behavior to websites. It allows features like form validation, animations, sliders, and real-time updates. Together with HTML and CSS, it forms the core of front-end web development.
                       </p>

                    </span>

                 </div>


              </div>

           </div>

        </div>
    </div>
  )
}
